import React, { createContext, useCallback, useContext, useState } from 'react';

const OrgContext = createContext({
    activeOrgId: null,
    activeOrgName: null,
    setActiveOrg: () => {},
});

export function OrgContextProvider({ children }) {
    const [activeOrgId, setActiveOrgId] = useState(
        () => localStorage.getItem('viewOrgId') || null
    );
    const [activeOrgName, setActiveOrgName] = useState(
        () => localStorage.getItem('viewOrgName') || null
    );

    const setActiveOrg = useCallback((id, name) => {
        setActiveOrgId(id);
        setActiveOrgName(name);
        if (id) {
            localStorage.setItem('viewOrgId', id);
            localStorage.setItem('viewOrgName', name ?? '');
        } else {
            localStorage.removeItem('viewOrgId');
            localStorage.removeItem('viewOrgName');
        }
    }, []);

    return (
        <OrgContext.Provider value={{ activeOrgId, activeOrgName, setActiveOrg }}>
            {children}
        </OrgContext.Provider>
    );
}

export function useOrg() {
    return useContext(OrgContext);
}
